export default {
    getAllProjects: state => {
        return state.projects.data;
    },
    getProjectsIsLoading: state => {
        return state.projects.dataIsLoading;
    },

};